import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export type InstallmentConfig = {
  months: number;
  label: string;
};

export const INSTALLMENT_CONFIG: Partial<Record<ShopifyStore, InstallmentConfig>> = {
  [ShopifyStore.US]: { months: 4, label: 'mo' },
  [ShopifyStore.AE]: { months: 4, label: 'mo' },
  [ShopifyStore.EU]: { months: 4, label: 'mo' },
  [ShopifyStore.GB]: { months: 4, label: 'mo' },
  [ShopifyStore.IN]: { months: 24, label: 'mo' },
};

export const getInstallmentConfig = (store: ShopifyStore | undefined): InstallmentConfig | null => {
  if (!store) return null;
  return INSTALLMENT_CONFIG[store] ?? null;
};

/** Whole-unit monthly estimate used by buy price lines (`or ₹X/mo ±`). */
export const getInstallmentAmount = (price: number, months: number): number =>
  Math.ceil(price / months);
